<template>
  <v-container fluid>
    <v-row class="mb-4" v-if="false">
      <v-col
        class="box-white text-center py-1 text-subtitle-2 text-sm-subtitle-1 text-md-subtitle-1 text-lg-subtitle-1 text-xl-subtitle-1"
      >
        <span> </span>
      </v-col>
    </v-row>

    <template v-if="showSubSamples">
      <v-container>
        <v-card height="auto">
          <v-card-text>
            <v-row align="center">
              <v-col cols="1">
                <v-btn
                  color="primary"
                  elevation="15"
                  fab
                  small
                  @click="showSubSamples = false"
                  class="mb-3 back-button"
                >
                  <v-icon> mdi-arrow-left </v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12">
                <MapSaplingInProgress
                  @subsamples="addSuSamples"
                  :target="currentTarget"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
    </template>

    <template v-else>
      <v-container v-if="!isQRActive">
        <v-row class="text-center mb-1">
          <v-col cols="12">
            <v-btn color="primary" @click="handleAddSubSample">
              <v-icon> mdi-map-marker-path </v-icon>
              {{ translations.label_add_subsamples }}
            </v-btn>
          </v-col>
          <v-col
            v-if="
              samplingPoints.filter((subSample) => !subSample.getData().kind)
                .length != 0
            "
          >
            <span>
              {{ translations.label_number_of_subsamples }}:
              {{
                samplingPoints.filter((subSample) => !subSample.getData().kind)
                  .length
              }}
            </span>
          </v-col>
        </v-row>

        <v-row
          class="text-center mb-1"
          v-if="isAvailableAddIssues() && isCropIssueTarget"
        >
          <v-col cols="12">
            <v-btn color="primary" @click="handleAddIssue">
              <v-icon> mdi-bug </v-icon>
              {{ translations.add_problems }}
            </v-btn>
          </v-col>
          <v-col
            v-if="
              samplingPoints.filter((subSample) => subSample.getData().kind)
                .length != 0
            "
          >
            <span>
              {{ translations.label_number_of_subsamples }}:
              {{
                samplingPoints.filter((subSample) => subSample.getData().kind)
                  .length
              }}
            </span>
          </v-col>
        </v-row>

        <v-form ref="form">
          <!-- Date Input with Menu Picker -->
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-menu
                v-model="showDatePicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    clearable
                    dense
                    :rules="validation(translations.field_required)"
                    :label="translations.sampling_date"
                    background-color="white"
                    v-model="formattedDate"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar"
                    @click:append="showDatePicker = true"
                    @click:clear="clearDate"
                  ></v-text-field>
                </template>

                <v-date-picker
                  v-model="form.endDate"
                  :locale="language"
                  color="orange darken-1"
                  header-color="orange darken-1"
                  @input="showDatePicker = false"
                  :show-current="false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <!-- Package Selection -->
          <v-row
            justify="center"
            class="my-0"
            v-if="packagesSolena.length != 0"
          >
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-autocomplete
                outlined
                clearable
                dense
                :rules="validation(translations.field_required)"
                :label="translations.label_select_package"
                background-color="white"
                v-model="form.packageSolena"
                :items="packagesSolena"
                :item-text="formatItemText"
                return-object
              ></v-autocomplete>
            </v-col>
          </v-row>

          <!-- Sampling Type Selection -->
          <div
            v-if="
              !permissions.find(
                (permission) => permission == 'sampling_hide_sample_type'
              )
            "
          >
            <v-row
              justify="center"
              class="my-0"
              v-if="
                packagesSolena.length == 0 ||
                  (form.packageSolena &&
                    form.packageSolena.name ==
                      translations.label_not_applicable)
              "
            >
              <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
                <v-autocomplete
                  outlined
                  clearable
                  dense
                  :rules="validation(translations.field_required)"
                  :label="translations.label_sampling_type"
                  background-color="white"
                  v-model="form.samplingType"
                  :items="samplingType"
                  item-text="text"
                  return-object
                ></v-autocomplete>
              </v-col>
            </v-row>
          </div>

          <!-- Vegetal Sample Type Selection -->
          <v-row
            justify="center"
            class="my-0"
            v-if="
              form.samplingType && form.samplingType.value == 'MAS_VEGETABLE'
            "
          >
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-autocomplete
                outlined
                clearable
                dense
                :rules="validation(translations.field_required)"
                :label="translations.label_plant_sample_type"
                background-color="white"
                v-model="form.vegetalSampleType"
                :items="vegetalSampleTypes"
                item-text="name"
                return-object
              ></v-autocomplete>
            </v-col>
          </v-row>

          <!-- Sample Description -->
          <v-row justify="center" class="mb-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="pb-0">
              <v-text-field
                outlined
                clearable
                dense
                :label="translations.label_sample_description"
                background-color="white"
                v-model="form.description"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <!-- Phenological Stage Selection -->
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-autocomplete
                outlined
                clearable
                dense
                :rules="validation(translations.field_required)"
                :label="translations.label_phonological_stage"
                background-color="white"
                v-model="form.phenologicalStage"
                :items="phenologicalStages"
                item-text="text"
                return-object
              ></v-autocomplete>
            </v-col>
          </v-row>

          <!-- Sick Plot Switch -->
          <v-row justify="center" class="my-0">
            <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
              <v-switch
                v-model="form.isPlot"
                :label="translations.label_sick_plot"
              ></v-switch>
            </v-col>
          </v-row>
        </v-form>

        <!-- QR Code Search -->
        <v-row justify="center" class="my-5">
          <v-col cols="12" xl="6" lg="7" md="7" sm="8" class="py-0">
            <v-autocomplete
              :label="translations.label_search_qr"
              prepend-inner-icon="mdi-magnify"
              dense
              clearable
              outlined
              :items="codes"
              :no-data-text="translations.label_qr_not_found"
              background-color="white"
              :search-input.sync="searchCodes"
              v-model="code"
              item-text="code"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <!-- Action Buttons -->
        <v-row justify="center" class="my-5">
          <v-col>
            <v-btn
              color="primary"
              block
              :disabled="!code"
              @click="finishSamplingProcess()"
            >
              {{ translations.label_finish_sampling }}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn color="warning" block @click="save()">
              {{ translations.label_finish_with_scanner }}
            </v-btn>
          </v-col>
          <v-col
            v-if="
              samplingPoints.filter((subSample) => subSample.getData().kind)
                .length != 0
            "
          >
            <v-btn
              color="primary"
              block
              @click="confirmationWithoutQrModal = true"
            >
              <v-icon> mdi-bug </v-icon>
              {{ translations.finish_sampling_without_qr }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <!-- QR Scanner Section -->
      <v-container v-else>
        <v-row justify="center">
          <v-col cols="9">
            <v-btn
              color="primary"
              elevation="15"
              fab
              small
              @click="isQRActive = false"
              class="mb-3 back-button"
            >
              <v-icon> mdi-arrow-left </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" xl="8" lg="8" md="8">
            <v-card
              :height="
                this.$vuetify.breakpoint.name != 'xl' &&
                this.$vuetify.breakpoint.name != 'lg' &&
                this.$vuetify.breakpoint.name != 'md'
                  ? '700'
                  : '600'
              "
            >
              <v-card-text class="text-center" v-if="errorCamera.length > 0">
                <span class="red--text text-caption"> {{ errorCamera }}</span>
              </v-card-text>

              <qrcode-stream @init="onInit" class="mb" @decode="onDecode">
                <canvas ref="canvas" style="display: none"></canvas>
              </qrcode-stream>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <!-- Confirmation Modal -->
    <ConfirmSamplingWithoutQr
      :title="translations.confirmation_wihout_qr"
      v-model="confirmationWithoutQrModal"
      @confirmation="finishSamplingProcess(true)"
    />

    <!-- Footer -->
    <v-footer class="text-caption text-center d-flex justify-center" fixed>
      D.R. © Solena Ag, Inc. {{ new Date().getFullYear() }}
    </v-footer>
  </v-container>
</template>

<script>
/**
 * SamplingProcess Component
 *
 * Comprehensive sampling process component that handles sample collection with
 * geographic subsamples, QR code scanning, and form data management. Supports
 * multiple sampling types, package selection, and issue tracking.
 *
 * @component
 * @example
 * <sampling-process />
 */

// ===== IMPORTS =====
// Validations
import {
  requiredValidation,
  requiredFValidation,
} from "@/helpers/validations.js";

// Vuex
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

// Components
import { QrcodeStream } from "vue-qrcode-reader";
import Compressor from "compressorjs";
import MapSaplingInProgress from "@/components/territory/MapSaplingInProgress.vue";
import ConfirmSamplingWithoutQr from "@/components/utils/GenericModal.vue";
import moment from "moment";

export default {
  name: "SamplingProcess",

  components: {
    QrcodeStream,
    MapSaplingInProgress,
    ConfirmSamplingWithoutQr,
  },

  // ===== REACTIVE STATE =====
  data() {
    return {
      /**
       * Array of phenological stages for plant growth
       * @type {Array<Object>}
       */
      phenologicalStages: [],

      /**
       * Controls QR scanner activation state
       * @type {boolean}
       */
      isQRActive: false,

      /**
       * Error message for camera initialization
       * @type {string}
       */
      errorCamera: "",

      /**
       * Form data object containing sampling information
       * @type {Object}
       * @property {Object} form.type - Analysis type
       * @property {string} form.description - Sample description
       * @property {Object} form.phenologicalStage - Plant growth stage
       * @property {boolean} form.isPlot - Sick plot indicator
       * @property {Object} form.packageSolena - Selected package
       * @property {Object} form.samplingType - Sampling methodology
       * @property {Object} form.vegetalSampleType - Plant sample type
       * @property {string} form.endDate - Sampling date
       */
      form: {
        type: "",
        description: "",
        phenologicalStage: "",
        isPlot: false,
        packageSolena: null,
        samplingType: null,
        vegetalSampleType: null,
        endDate: "",
      },

      /**
       * Available QR codes for selection
       * @type {Array<Object>}
       */
      codes: [],

      /**
       * Search input for QR codes
       * @type {string|null}
       */
      searchCodes: null,

      /**
       * Selected QR code
       * @type {string|null}
       */
      code: null,

      /**
       * Available Solena packages
       * @type {Array<Object>}
       */
      packagesSolena: [],

      /**
       * Distributor organization ID
       * @type {string}
       */
      distributor: localStorage.getItem("distributionOrganizationId"),

      /**
       * Available sampling types
       * @type {Array<Object>}
       */
      samplingType: [],

      /**
       * Available vegetal sample types
       * @type {Array<Object>}
       */
      vegetalSampleTypes: [],

      /**
       * Controls subsamples map visibility
       * @type {boolean}
       */
      showSubSamples: false,

      /**
       * Collected subsamples data
       * @type {Array<Object>}
       */
      subsamples: [],

      /**
       * Captured QR code image
       * @type {string|null}
       */
      capturedImage: null,

      /**
       * Video element reference for QR scanner
       * @type {HTMLVideoElement|null}
       */
      videoElement: null,

      /**
       * Current organization ID
       * @type {string|null}
       */
      organizationId: null,

      /**
       * Current target type for sampling (subsample/issue)
       * @type {string}
       */
      currentTarget: "",

      /**
       * Controls confirmation modal visibility
       * @type {boolean}
       */
      confirmationWithoutQrModal: false,

      /**
       * Controls date picker visibility
       * @type {boolean}
       */
      showDatePicker: false,
    };
  },

  // ===== COMPOSABLES & STORES =====
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    ...mapState("areasList", ["areaSelected", "crops"]),
    ...mapState("session", ["language", "permissions"]),
    ...mapState("samples", ["samplingPoints"]),
  },

  // ===== COMPUTED PROPERTIES =====
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    ...mapState("areasList", ["areaSelected", "crops"]),
    ...mapState("session", ["language", "permissions"]),
    ...mapState("samples", ["samplingPoints"]),

    /**
     * Current translations from store
     * @returns {Object} Translation key-value pairs
     */
    translations() {
      return this.currentTranslations;
    },

    /**
     * Formatted date for display in the text field
     * @returns {string} Formatted date string
     */
    formattedDate: {
      get() {
        if (!this.form.endDate) return "";
        const date = new Date(this.form.endDate);
        return date.toLocaleDateString(this.language); // Localized format
      },
      set(value) {
        // Convert from localized format to ISO if needed
        if (value) {
          const date = new Date(value);
          this.form.endDate = date.toISOString().split("T")[0];
        } else {
          this.form.endDate = "";
        }
      },
    },

    /**
     * Determines if current crop supports issue tracking
     * @returns {boolean} True if crop supports issue tracking
     */
    isCropIssueTarget() {
      if (
        !this.areaSelected ||
        !this.areaSelected.cropCycles ||
        this.areaSelected.cropCycles.length === 0
      )
        return false;

      const currentCrop = this.areaSelected.cropCycles[
        this.areaSelected.cropCycles.length - 1
      ].crop.cropName;

      if (!currentCrop) return false;

      switch (currentCrop) {
        case "avocado":
          return true;
        default:
          return false;
      }
    },
  },

  // ===== LIFECYCLE HOOKS =====
  created() {
    this.initializeDropdownData();
  },

  async mounted() {
    try {
      this.SET_LOADER(true);
      await this.initializeComponent();
    } catch (error) {
      console.error("Component initialization error:", error);
      this.showErrorAlert(this.translations.advice_error);
    } finally {
      this.SET_LOADER(false);
    }
  },

  updated() {
    this.configureAppBar();
  },

  beforeDestroy() {
    this.cleanupComponent();
  },

  // ===== METHODS =====
  methods: {
    ...mapActions("samples", [
      "saveNotGeoSample",
      "saveSampleNotAdvisor",
      "checkPermissionSampleNotAdvisor",
    ]),
    ...mapActions("areasList", ["getAreaById", "finishSampling"]),
    ...mapMutations("areasList", ["SET_AREA_SELECTED"]),
    ...mapActions("packageSolena", [
      "getPackagesByDistributor",
      "getPackagesByClient",
    ]),
    ...mapActions("container", ["getContainers"]),
    ...mapActions("samples", ["uploadImage"]),
    ...mapMutations(["SET_APPBAR_OPTIONS", "SET_LOADER"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations("samples", ["SET_SAMPLING_POINTS"]),

    // ===== INITIALIZATION METHODS =====
    /**
     * Initializes dropdown data with translations
     */
    initializeDropdownData() {
      this.phenologicalStages = [
        {
          text: this.translations.phenologicalStages["Transplanting"],
          value: "Transplanting",
        },
        {
          text: this.translations.phenologicalStages["Vegetative growth"],
          value: "Vegetative growth",
        },
        { text: this.translations.phenologicalStages["Bloom"], value: "Bloom" },
        {
          text: this.translations.phenologicalStages["Harvest"],
          value: "Harvest",
        },
        {
          text: this.translations.phenologicalStages["Pre-planting"],
          value: "Pre-planting",
        },
        {
          text: this.translations.phenologicalStages["Sowing"],
          value: "Sowing",
        },
        {
          text: this.translations.phenologicalStages["Sprout"],
          value: "Sprout",
        },
        {
          text: this.translations.phenologicalStages["Tuberization"],
          value: "Tuberization",
        },
        {
          text: this.translations.phenologicalStages["Tuber filling"],
          value: "Tuber filling",
        },
        {
          text: this.translations.phenologicalStages["Foliage development"],
          value: "Foliage development",
        },
        {
          text: this.translations.phenologicalStages["Foliar expansion"],
          value: "Foliar expansion",
        },
        {
          text: this.translations.phenologicalStages["First leaf"],
          value: "First leaf",
        },
        {
          text: this.translations.phenologicalStages["Third leaf"],
          value: "Third leaf",
        },
        {
          text: this.translations.phenologicalStages["Fifth leaf"],
          value: "Fifth leaf",
        },
        {
          text: this.translations.phenologicalStages["Start of bulbing"],
          value: "Start of bulbing",
        },
        {
          text: this.translations.phenologicalStages["Bulb growth"],
          value: "Bulb growth",
        },
        {
          text: this.translations.phenologicalStages["Fruit maturity"],
          value: "Fruit maturity",
        },
        {
          text: this.translations.phenologicalStages["Sprouting"],
          value: "Sprouting",
        },
      ];

      this.analysisType = [
        { name: this.translations.analysisTypes["INITIAL"], value: "INITIAL" },
        {
          name: this.translations.analysisTypes["MONITORING"],
          value: "MONITORING",
        },
      ];

      this.samplingType = [
        { text: this.translations.samplingType["CLASSIC"], value: "CLASSIC" },
        {
          text: this.translations.samplingType["MAS_VEGETABLE"],
          value: "MAS_VEGETABLE",
        },
      ];

      this.vegetalSampleTypes = [
        {
          name: this.translations.vegetalSampleTypes["Seedling"],
          value: "Seedling",
        },
        { name: this.translations.vegetalSampleTypes["Root"], value: "Root" },
        { name: this.translations.vegetalSampleTypes["Seed"], value: "Seed" },
        { name: this.translations.vegetalSampleTypes["Stem"], value: "Stem" },
        { name: this.translations.vegetalSampleTypes["Leaf"], value: "Leaf" },
        { name: this.translations.vegetalSampleTypes["Fruit"], value: "Fruit" },
        {
          name: this.translations.vegetalSampleTypes["Flower"],
          value: "Flower",
        },
      ];
    },

    /**
     * Initializes component data and fetches required information
     */
    async initializeComponent() {
      const response = await this.getAreaById(this.$route.params.areaId);

      if (response && !response.error) {
        this.SET_AREA_SELECTED(response.soilArea);
        await this.init();
      } else {
        this.showErrorAlert(this.translations.advice_error);
      }
    },

    /**
     * Initializes user-specific data and packages
     */
    async init() {
      const user = JSON.parse(localStorage.getItem("user"));
      this.organizationId =
        user.role === "ORG_USER" || user.role === "ORG_USER_ADMIN"
          ? localStorage.getItem("organizationId")
          : localStorage.getItem("clientId");

      await this.getPackges();
    },

    /**
     * Configures app bar options
     */
    configureAppBar() {
      this.SET_APPBAR_OPTIONS({
        leftButton: "back-arrow",
        funcLeftButton: this.goBack,
      });
    },

    /**
     * Cleans up component resources
     */
    cleanupComponent() {
      this.SET_SAMPLING_POINTS([]);
    },

    // ===== DATA METHODS =====
    /**
     * Fetches available packages based on user role
     */
    async getPackges() {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        let response = null;

        if (user.role === "ORG_USER" || user.role === "ORG_USER_ADMIN") {
          response = await this.getPackagesByClient({
            commercialOrganizationId: this.organizationId,
          });
        } else {
          response = await this.getPackagesByDistributor({
            distributorId: this.distributor,
          });
        }

        this.packagesSolena = response;

        // Add "Not Applicable" option if user has specific permission
        if (
          this.permissions.find(
            (permission) => permission === "not_package_in_sampling"
          ) &&
          this.packagesSolena.length !== 0
        ) {
          this.packagesSolena.unshift({
            name: this.translations.label_not_applicable,
          });
        }
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    },

    // ===== UTILITY FUNCTIONS =====
    /**
     * Formats item text for package display
     * @param {Object} item - Package item
     * @returns {string} Formatted display text
     */
    formatItemText(item) {
      return item.laboratoryName
        ? `${item.name} - ${item.laboratoryName}`
        : `${item.name}`;
    },

    /**
     * Generates required field validation rules
     * @param {string} name - Field name for error message
     * @returns {Array} Validation rules array
     */
    validation(name) {
      return requiredValidation(name);
    },

    /**
     * Navigates back to territory view
     */
    goBack() {
      this.$router.push("/territory");
    },

    /**
     * Clears the selected date
     */
    clearDate() {
      this.form.endDate = "";
      this.showDatePicker = false;
    },

    // ===== EVENT HANDLERS =====
    /**
     * Handles subsamples data from map component
     * @param {Array} subsamples - Collected subsamples data
     */
    addSuSamples(subsamples) {
      this.subsamples = subsamples;
      this.showSubSamples = false;
    },

    /**
     * Initiates subsample collection process
     */
    handleAddSubSample() {
      this.currentTarget = "subsample";
      this.showSubSamples = true;
      this.$nextTick(() => {
        this.SET_APPBAR_OPTIONS({});
      });
    },

    /**
     * Initiates issue collection process
     */
    handleAddIssue() {
      this.currentTarget = "issue";
      this.showSubSamples = true;
      this.$nextTick(() => {
        this.SET_APPBAR_OPTIONS({});
      });
    },

    /**
     * Checks if issue tracking is available for current distributor
     * @returns {boolean} True if issue tracking is available
     */
    isAvailableAddIssues() {
      return this.distributor === "646d024a6e770f61219d2e3c";
    },

    // ===== QR SCANNER METHODS =====
    /**
     * Initializes QR scanner
     * @param {Promise} promise - Scanner initialization promise
     */
    async onInit(promise) {
      try {
        const { capabilities } = await promise;

        this.$nextTick(() => {
          this.videoElement = document.querySelector("video");
        });
      } catch (error) {
        this.handleCameraError(error);
      }
    },

    /**
     * Handles camera initialization errors
     * @param {Error} error - Camera error object
     */
    handleCameraError(error) {
      const errorMessages = {
        NotAllowedError: this.translations
          .label_user_denied_camera_access_permission,
        NotFoundError: this.translations
          .label_no_suitable_camera_device_installed,
        NotSupportedError: this.translations
          .label_page_not_served_over_https_or_localhost,
        NotReadableError: this.translations.label_camera_may_be_in_use,
        OverconstrainedError: this.translations
          .label_requested_front_camera_although_none_available,
        StreamApiNotSupportedError: this.translations
          .label_browser_lacks_features,
      };

      this.errorCamera =
        errorMessages[error.name] || this.translations.advice_error;
    },

    /**
     * Processes decoded QR code data
     * @param {string} data - Decoded QR code data
     */
    async onDecode(data) {
      try {
        this.SET_LOADER(true);
        await this.processQRCode(data);
      } catch (error) {
        console.error("QR processing error:", error);
        this.showErrorAlert(this.translations.advice_error);
      } finally {
        this.SET_LOADER(false);
      }
    },

    /**
     * Processes QR code and completes sampling
     * @param {string} qrData - QR code data
     */
    async processQRCode(qrData) {
      const qrImage = await this.captureAndCompressQRImage();
      const subSamples = await this.processSubSamples();
      const samplingConfig = this.getSamplingConfiguration();

      const payload = {
        folio: qrData,
        areaId: this.areaSelected._id,
        sampleId: this.areaSelected.samples[
          this.areaSelected.samples.length - 1
        ]._id,
        client: this.areaSelected.organization,
        qr: qrImage.urlImg,
        dateTaken: new Date(),
        description: this.form.description,
        tracingStatus: this.form.type.value,
        sampleType: samplingConfig.samplingType,
        vegetableType: samplingConfig.vegetalSampleType,
        phenologicalStage: this.form.phenologicalStage.value,
        packageSolena: samplingConfig.packageSolena,
        matchPackage: samplingConfig.matchPackage,
        isSickPlot: this.form.isPlot,
        subsamples: subSamples,
        endDate: this.form.endDate,
      };

      await this.submitSamplingData(payload);
    },

    /**
     * Captures and compresses QR code image from video stream
     * @returns {Object} Uploaded image data
     */
    async captureAndCompressQRImage() {
      const canvas = this.$refs.canvas;
      canvas.width = this.videoElement.videoWidth;
      canvas.height = this.videoElement.videoHeight;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(this.videoElement, 0, 0, canvas.width, canvas.height);

      this.capturedImage = canvas.toDataURL("image/jpeg");
      const imgFile = this.dataURLtoFile(this.capturedImage);

      const compressedBlobQR = await new Promise((resolve, reject) => {
        new Compressor(imgFile, {
          quality: 0.6,
          maxWidth: 800,
          maxHeight: 800,
          success: resolve,
          error: reject,
        });
      });

      const fileName = `${Date.now()}`;
      const fileWithNewName = new File([compressedBlobQR], fileName, {
        type: compressedBlobQR.type,
      });

      const formData = new FormData();
      formData.append("file", fileWithNewName);

      return await this.uploadImage(formData);
    },

    // ===== SAMPLING PROCESS METHODS =====
    /**
     * Validates form and activates QR scanner
     */
    async save() {
      try {
        if (!this.isQRActive && this.$refs.form.validate()) {
          this.isQRActive = true;
        }
      } catch (error) {
        console.error("Save error:", error);
        this.showErrorAlert(this.translations.advice_error);
      }
    },

    /**
     * Completes sampling process with or without QR code
     * @param {boolean} withoutQr - Flag to indicate QR-less completion
     */
    async finishSamplingProcess(withoutQr = false) {
      try {
        if (this.$refs.form.validate()) {
          this.SET_LOADER(true);

          const subSamples = await this.processSubSamples(withoutQr);
          const samplingConfig = this.getSamplingConfiguration();
          const folio = withoutQr ? "" : this.code;

          const payload = {
            folio: folio,
            areaId: this.areaSelected._id,
            sampleId: this.areaSelected.samples[
              this.areaSelected.samples.length - 1
            ]._id,
            client: this.areaSelected.organization,
            qr: "",
            dateTaken: new Date(),
            description: this.form.description,
            tracingStatus: this.form.type.value,
            sampleType: samplingConfig.samplingType,
            vegetableType: samplingConfig.vegetalSampleType,
            phenologicalStage: this.form.phenologicalStage.value,
            packageSolena: samplingConfig.packageSolena,
            matchPackage: samplingConfig.matchPackage,
            isSickPlot: this.form.isPlot,
            subsamples: subSamples,
            endDate: this.form.endDate,
          };

          await this.submitSamplingData(payload);
        }
      } catch (error) {
        console.error("Sampling process error:", error);
        this.showErrorAlert(this.translations.advice_error);
      } finally {
        this.SET_LOADER(false);
      }
    },

    /**
     * Processes subsamples data with image compression
     * @param {boolean} issuesOnly - Process only issues when true
     * @returns {Array} Processed subsamples array
     */
    async processSubSamples(issuesOnly = false) {
      const compressionOptions = {
        quality: 0.6,
        maxWidth: 800,
        maxHeight: 800,
      };

      const finalSamplingPoints = issuesOnly
        ? this.samplingPoints.filter(
            (subSample) =>
              subSample.getData().kind && subSample.getData().kind.length > 0
          )
        : this.samplingPoints;

      const processedSamples = [];

      for (const subSample of finalSamplingPoints) {
        if (subSample.getGeometry().lat && subSample.getGeometry().lng) {
          const newSubSample = {
            date: moment(
              subSample.getData().date,
              "YYYY:MM:DD HH:mm:ss"
            ).toDate(),
            lat: subSample.getGeometry().lat,
            lng: subSample.getGeometry().lng,
            kind: subSample.getData().kind || "",
            issue: subSample.getData().issue || "",
            isGeneric: subSample.getData().isGeneric || false,
            subSamplePhoto: "",
          };

          if (subSample.getData().subSamplePhoto) {
            const compressedBlob = await new Promise((resolve, reject) => {
              new Compressor(subSample.getData().subSamplePhoto, {
                ...compressionOptions,
                success: resolve,
                error: reject,
              });
            });

            const uniqueFileName = `${Date.now()}`;
            const fileWithNewName = new File([compressedBlob], uniqueFileName, {
              type: compressedBlob.type,
            });

            const formData = new FormData();
            formData.append("file", fileWithNewName);
            const { urlImg } = await this.uploadImage(formData);
            newSubSample.subSamplePhoto = urlImg;
          }

          processedSamples.push(newSubSample);
        }
      }

      return processedSamples;
    },

    /**
     * Determines sampling configuration based on form data and permissions
     * @returns {Object} Sampling configuration object
     */
    getSamplingConfiguration() {
      const config = {
        samplingType: "",
        vegetalSampleType: "",
        packageSolena: null,
        matchPackage: false,
      };

      const hasSamplingHidePermission = this.permissions.find(
        (permission) => permission === "sampling_hide_sample_type"
      );

      if (hasSamplingHidePermission) {
        config.samplingType = "CLASSIC";
      } else if (this.packagesSolena.length === 0) {
        config.samplingType = this.form.samplingType.value;
        if (this.form.samplingType.value === "MAS_VEGETABLE") {
          config.vegetalSampleType = this.form.vegetalSampleType.value;
        }
      } else {
        const currentCrop = this.areaSelected.cropCycles[
          this.areaSelected.cropCycles.length - 1
        ].crop.cropName;

        config.matchPackage =
          this.form.packageSolena.crop &&
          this.form.packageSolena.crop.find(
            (element) => element === currentCrop
          )
            ? true
            : false;

        config.packageSolena = this.form.packageSolena._id;

        if (this.form.packageSolena.isPlantTissue) {
          config.samplingType = "MAS_VEGETABLE";
          config.vegetalSampleType = this.form.packageSolena.value.vegetalSampleType;
        } else {
          config.samplingType = "CLASSIC";
        }
      }

      return config;
    },

    /**
     * Submits sampling data to backend and handles response
     * @param {Object} payload - Sampling data payload
     */
    async submitSamplingData(payload) {
      const response = await this.finishSampling(payload);

      const responseHandlers = {
        1: () =>
          this.showErrorAlert(
            this.translations.label_enter_an_unregistered_folio
          ),
        2: () =>
          this.showErrorAlert(this.translations.label_enter_a_valid_folio),
        3: () => {
          this.showSuccessAlert(
            this.translations.label_sample_successfully_registered
          );
          this.goBack();
        },
        4: () =>
          this.showErrorAlert(this.translations.label_sample_already_completed),
      };

      if (responseHandlers[response.code]) {
        responseHandlers[response.code]();
      }
    },

    // ===== UTILITY FUNCTIONS =====
    /**
     * Converts data URL to File object
     * @param {string} dataURL - Data URL string
     * @returns {File} File object
     */
    dataURLtoFile(dataURL) {
      const arr = dataURL.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      const u8arr = new Uint8Array(bstr.length);

      for (let i = 0; i < bstr.length; i++) {
        u8arr[i] = bstr.charCodeAt(i);
      }

      return new File([u8arr], "evidence.jpg", { type: mime });
    },

    /**
     * Shows error alert
     * @param {string} message - Error message
     */
    showErrorAlert(message) {
      this.SET_ALERT_TYPE({
        visible: true,
        type: "error",
        text: message,
        timeout: 5000,
      });
    },

    /**
     * Shows success alert
     * @param {string} message - Success message
     */
    showSuccessAlert(message) {
      this.SET_ALERT_TYPE({
        visible: true,
        type: "success",
        text: message,
        timeout: 5000,
      });
    },
  },

  // ===== WATCHERS =====
  watch: {
    /**
     * Watches for QR code search input changes
     * @param {string} value - Search input value
     */
    async searchCodes(value) {
      if (!value) return;

      try {
        const response = await this.getContainers({ code: value });
        this.codes = response.containers;
      } catch (error) {
        console.error("QR search error:", error);
      }
    },
  },
};
</script>

<style scoped>
.box-white {
  background: #ffffff;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .back-button {
    margin-bottom: 16px;
  }
}

/* Accessibility improvements */
@media (prefers-reduced-motion: reduce) {
  .v-menu__content {
    transition: none;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .box-white {
    background: #1e1e1e;
  }
}
</style>
